import { render } from "./EntryForm2.vue?vue&type=template&id=0a135484"
import script from "./EntryForm2.vue?vue&type=script&lang=js"
export * from "./EntryForm2.vue?vue&type=script&lang=js"

import "./EntryForm2.vue?vue&type=style&index=0&id=0a135484&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__